import React, { useState } from 'react'

import FormInput from './FormInput'
import classnames from 'classnames'

import '../styles/subscription-extra-tip-price.scss'

const SubscriptionExtraTipPrice = ({ extraTipCents, setExtraTipCents }) => {
  const [isShow, setIsShow] = useState(false)
  const value = extraTipCents === 0 ? ' ' : extraTipCents / 100
  return (
    <div className="account-subscription-extra-tip-price">
      <div
        className={classnames('account-subscription-extra-tip-price__button', {
          'account-subscription-extra-tip-price__button--active': isShow
        })}
        onClick={handleShow}>
        Хотите дополнительно поддержать Arzamas и назначить свою цену за подписку? Жмите сюда!
      </div>
      <FormInput
        className={classnames('account-subscription-extra-tip-price__input-wrap', {
          'account-subscription-extra-tip-price__input-wrap--active': isShow
        })}
        classNameContainer="account-subscription-extra-tip-price__input-container"
        classNameInput="account-subscription-extra-tip-price__input"
        classNameLabel="account-subscription-extra-tip-price__label"
        label="Впишите, сколько вы готовы доплачивать сверху к выбранному типу подписки. Спасибо!"
        placeholder="Например, 100"
        value={value}
        type="number"
        onChange={handleInputChange}
      />
    </div>
  )

  function handleShow() {
    setIsShow(prevState => !prevState)
  }

  function handleInputChange(event) {
    if (Number(event.target.value) <= 0) {
      setExtraTipCents(0)
    } else {
      return setExtraTipCents(Number(event.target.value) * 100)
    }
  }
}

export default SubscriptionExtraTipPrice
